import { Container } from "../../../../components/formulario/styled"
import HeaderEventoChekin from "./header"
import TabelaListaEventosBatismo from "./tabela"


export const ContainerEventosCheckin = () => {
  return (
    <>
      <Container>
        <HeaderEventoChekin/>
        <TabelaListaEventosBatismo/>
      </Container>
    </>
  )
}
